export default "__VITE_ASSET__BQwcgm6P__"